import { observer } from "mobx-react-lite";

import { SvgGenerator, type Path } from "@/components/expression/svgUtils/SvgGenerator";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { twMerge } from "@/utils/twMerge";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";
import type { NodeSize } from "@corca/data";

const BRACE_RADIUS_MAP: Record<NodeSize, number> = {
  sm: 5,
  xs: 4,
  xxs: 2,
  xxxs: 1.5,
};

const createBracePath = (radius: number): Path => {
  return [
    "stroke",
    `M 1 {100h-1} A ${radius} ${radius} 0 0 1 ${radius + 1} {50h} L {50w-${radius}} {50h} A ${radius} ${radius} 0 0 0 {50w} {25h} A ${radius} ${radius} 0 0 0 {50w+${radius}} {50h} L {100w-${radius + 1}} {50h} A ${radius} ${radius} 0 0 1 {100w-1} {100h-1}`,
  ];
};

type Props = {
  node: DecoratorNodeModel;
  position?: "over" | "under";
};

export const Brace = observer(function Brace({ node: _node, position = "over" }: Props) {
  const { view, size } = useNodeStyle();
  const isTextView = view === "text";
  const strokeWidth = isTextView ? 1 : 1.24;
  const path = createBracePath(BRACE_RADIUS_MAP[size]);

  return (
    <div
      className={twMerge(
        "absolute -left-[1px] -right-[1px] text-document-text h-2.5",

        size === "sm" && "h-2.5",
        size === "xs" && "h-2",
        size === "xxs" && "h-1.5",

        position === "over" && "top-[2px] -translate-y-full",
        position === "under" && "bottom-[2px] translate-y-full rotate-180",
      )}
    >
      <SvgGenerator paths={[path]} strokeWidth={strokeWidth} />
    </div>
  );
});
